import React from "react";
import axios from "axios";
import { API_BASE_URL, LAMBDA_BASE_URL } from "../../../constants";
import { getDomainId } from "utils/utils";
import { getDomainIdSync } from "utils/utils";



const ExportL = ({ searchQuery = "", filename = "export.csv", startDate, endDate}) => {
  const exportToCSV = async () => {
    try {
      const domainId = await getDomainIdSync();
      const response = await axios.get(`${LAMBDA_BASE_URL}/likes`, {
        params: {
          search: searchQuery,
          limit: 10000,
          page: 1,
          start_date : startDate,
          end_date : endDate,
          
        },
        headers: {
          "DOMAIN-TOKEN": domainId,
        },
      });

      const data = response?.data?.result?.search_list || [];

      if (!Array.isArray(data) || data.length === 0) {
        alert("No data to export");
        return;
      }

      const headers = ["question","answer","ip_address","created_at","likes"]
      const csvRows = [headers.join(",")];

      data.forEach((row) => {
        const values = headers.map((header) => `"${row[header] ?? ""}"`);
        csvRows.push(values.join(","));
      });

      const csvString = "\uFEFF" + csvRows.join("\n"); // UTF-8 BOM
      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      alert("Export failed");
    }
  };

  return (
    <button
      onClick={exportToCSV}
                 style={{
            padding: "10px 12px",
            borderRadius: "6px",
            background: "#219297",
            color: "white",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            maxWidth: "100%",
            boxShadow:
              "-2px 0 4px rgba(0,0,0,0.05), 2px 0 4px rgba(0,0,0,0.05), 0 2px 6px rgba(0,0,0,0.1)",
            fontWeight: "600",
            transition: "filter 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.filter = "brightness(1.1)")}
          onMouseLeave={(e) => (e.currentTarget.style.filter = "brightness(1)")}
    >
      Export to CSV
    </button>
  );
};

export default ExportL;
